import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

export default function AboutPreview() {
  const { t } = useContent('home');
  const { t: tc } = useContent('common');
  const { t: imgT } = useContent('images');

  return (
    <section className="py-20 bg-background-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-14">
          <div className="w-full lg:w-[55%] flex justify-center">
            <div className="relative w-full max-w-[540px] flex items-center justify-center">
              <img
                alt="Equipo profesional de FMO LLC instalando aislamiento"
                className="w-full h-auto max-h-[680px] object-contain rounded-2xl"
                src={imgT('about_preview')}
              />
              <div className="absolute bottom-6 left-6 bg-background-200 border border-primary-500/40 text-foreground-50 px-5 py-4 rounded-xl">
                <p className="text-3xl font-extrabold text-primary-500">15+</p>
                <p className="text-xs text-foreground-400 mt-0.5">{tc('common_years_experience')}</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[45%]">
            <span className="text-primary-500 text-xs font-semibold uppercase tracking-widest">{t('about_badge')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight">
              {t('about_title')}
            </h2>
            <p className="text-foreground-400 mt-5 text-base leading-relaxed">
              {t('about_desc1')}
            </p>
            <p className="text-foreground-400 mt-3 text-base leading-relaxed">
              {t('about_desc2')}
            </p>
            <p className="text-foreground-50 font-semibold text-base mt-6 italic">{t('about_serving')}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                  <i className="ri-tools-line text-primary-500 text-base w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-foreground-400 text-sm font-medium">{t('about_service_spray')}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                  <i className="ri-drop-line text-primary-500 text-base w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-foreground-400 text-sm font-medium">{t('about_service_batt')}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                  <i className="ri-home-4-line text-primary-500 text-base w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-foreground-400 text-sm font-medium">{t('about_service_attic')}</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                  <i className="ri-building-line text-primary-500 text-base w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-foreground-400 text-sm font-medium">{t('about_service_commercial')}</span>
              </div>
            </div>
            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3.5 rounded-full text-sm transition-colors cursor-pointer mt-8"
            >
              {tc('common_learn_more')}
              <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}